'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _Media = require('./Media.css');

var _Media2 = _interopRequireDefault(_Media);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Media = (_dec = (0, _reactCssModules2.default)(_Media2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Media, _Component);

  function Media(props) {
    (0, _classCallCheck3.default)(this, Media);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Media.__proto__ || (0, _getPrototypeOf2.default)(Media)).call(this, props));

    _this.pressHits = [{
      outlet: 'Fast Company',
      headline: 'New investment site helps people avoid funding gun manufacturers, military contractors',
      link: 'https://www.fastcompany.com/40589913/new-investment-site-helps-people-avoid-funding-gun-manufacturers-military-contractors'
    }, {
      outlet: 'Pensions and Investments',
      headline: 'New tool lets investors scrutinize funds for weapons companies',
      link: 'http://www.pionline.com/article/20180806/PRINT/180809907/new-tool-lets-investors-scrutinize-funds-for-weapons-companies'
    }, {
      outlet: 'Common Dreams',
      headline: 'Are You Funding Gun Violence?',
      link: 'https://www.commondreams.org/views/2018/06/27/are-you-funding-gun-violence'
    }, {
      outlet: 'Common Dreams',
      headline: 'Who Is Making a Killing on Killing?',
      link: 'https://www.commondreams.org/views/2018/06/26/who-making-killing-killing'
    }, {
      outlet: 'As You Sow blog',
      headline: 'In the wake of yet another mass shooting, a call for weapons-free finance',
      link: 'https://www.asyousow.org/blog/2018/2/27/in-the-wake-of-yet-another-mass-shooting-a-call-for-weapons-free-finance'
    }];

    _this.clickViewMore = function (release) {
      var newState = {};
      newState[release] = !_this.state[release];
      _this.setState(newState);
    };

    _this.renderButton = function (label, title, date, subtitle, renderFn) {
      var btnLabel = !_this.state[label] ? 'View the Full Release' : 'View Less';
      return _react2.default.createElement(
        'div',
        { styleName: 'press-release-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'press-release-title' },
          title
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            date,
            ' \u2014 ',
            subtitle
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'press-release-button', onClick: function onClick() {
              return _this.clickViewMore(label);
            } },
          _react2.default.createElement('i', {
            styleName: 'press-release-icon',
            className: _this.state[label] ? 'fa fa-caret-down' : 'fa fa-caret-right'
          }),
          '\xA0',
          btnLabel
        ),
        _this.state[label] ? renderFn() : null
      );
    };

    _this.renderReleaseLaunchButton = function () {
      var label = 'launch';
      var title = 'First of Its Kind Web Tool Lets You Know if You’re Funding Gun Violence and War';
      var date = 'June 26, 2018';
      var subtitle = 'Weapon Free Funds, a new tool from non-profit groups As You Sow and CODEPINK, was released today';
      var renderFn = function renderFn() {
        return _this.renderReleaseLaunch();
      };

      return _this.renderButton(label, title, date, subtitle, renderFn);
    };

    _this.renderReleaseLaunch = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'release-wrap' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'OAKLAND, CA \u2014 June 26, 2018 \u2014 Weapon Free Funds'
          ),
          ', a new tool from non-profit groups As You Sow and CODEPINK, was released today to help individuals, communities, universities and others review their mutual fund investments for holdings in military contractors and gun manufacturers and retailers. Handguns, assault rifles, ammunition, cluster munitions, landmines and nuclear weapons are often embedded in commonly-held mutual funds and ETFs.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Employer-offered 401(k)s, personal mutual fund portfolios and pension funds are likely to be invested in weapons manufacturers, including large defense contractors like Lockheed Martin and Raytheon, and gun companies such as American Outdoor Brands\u2014the company that makes the assault rifle that was used in the Parkland, Florida, school shooting.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CIf you\u2019re an investor who doesn\u2019t want to support the weapons industry, you have to first know what you own,\u201D said Andrew Behar, CEO of As You Sow. \u201CIt\u2019s important that people are offered the choice to invest responsibly and avoid companies profiting from violence\u2014especially when many of the clean funds outperform.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Weapon Free Funds, covering 3,000 of the most commonly-owned U.S. mutual funds from major asset managers like Vanguard, Fidelity and BlackRock, allows investors to find out if their mutual fund investments are being used to finance makers of military weapons and civilian firearms, and to find alternative, socially-responsible options that avoid the war economy. Investors can easily see how their investments support major military contractors, cluster munitions (banned in 100+ countries), nuclear weapons, gun manufacturers and gun retailers.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The details of child concentration camps at our borders is a shining example of how military contractors do business, and our investments are subsidizing humanitarian crises and untold destruction both at home and around the world.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CThere should be no profit from war. We should not be making a killing on killing,\u201D Jodie Evans, co-founder of CODEPINK, said. \u201CTo end violence and war we can start with our cities, states, schools, and churches acting from their values.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The good news is that more than $40 billion has already been divested from war and weapons, and these weapon-free funds can be found in the database.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '"Domini Funds has always sought to avoid investing in weapons,\u201D Amy Domini, founder of Domini Funds, said. \u201COur principles of universal human dignity and ecological sustainability mean that we must exclude the manufacturers of products that are only intended to cause harm to people and the planet. You can invest wisely without sacrificing your values.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Activists have been speaking out against investing in war. Earlier this year, activists rallied in front of BlackRock, the world\u2019s largest investment firm, demanding an end to profiting from war, death and destruction. As we sludge through another year of the wars without end, individuals and institutions are speaking up and removing their assets from war. Years of diverting limited federal resources to line the pockets of CEOs, who are making millions while workers cannot afford basic necessities like food and shelter, has resulted in a growing movement to align our investments with our values. Weapon Free Funds brings transparency to this movement.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '"Chorus Foundation has never invested in weapons, because it does not align with our values,\u201D Cuong Hoang of the Chorus Foundation said. \u201CBuilding community power to dismantle extractive economies means that we focused our investments on solutions.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CAs we continue to spend out our family foundation, we continue to be, and always have been, committed to investing in funds and businesses that promote an economy of peace. We will never profit from war," said Lauren Embrey of the Embrey Family Foundation'
        ),
        _react2.default.createElement(
          'p',
          null,
          'CODEPINK is leading an 85-member coalition in their Divest from the War Machine campaign  to use this tool to encourage mayors, governors, universities and pension funds managers to stop funding violence. Beyond moral concerns, weapon investments carry real financial risks. Recently, the stock market reacted to news of peace on the Korean peninsula with a significant drop in weapons manufacturer stock. Institutions have also divested from weapons and see marked increase in performance, including Hampshire College in Massachusetts.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '"One might think this [divesting from weapons] is a risky approach for a small college,\u201D John Courtmanche, spokesman for Hampshire College, said. \u201CBut following this policy since 2011, our average five-year investment returns have performed better (6.4%) than the average return of the more than 800 colleges tracked by both NACUBO Commonfund Study (5.4%) and Bloomberg Endowment Index (4.5%). In the fiscal year ending June, 2017, Hampshire logged an annual return of 24.5%, much higher than the industry average of 12.7% that year for endowments and foundations."'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Weapon Free Funds'
          ),
          ' is available at ',
          _react2.default.createElement(
            _components.Link,
            { to: _config2.default.routes.home, title: 'Home | Weapon Free Funds', xstrong: true },
            'weaponfreefunds.org'
          ),
          '. To learn more about the movement to say no to guns, war, and violence visit ',
          _react2.default.createElement(
            _components.Link,
            { to: _config2.default.links.dfw, title: 'Divest from the War Machine', xstrong: true },
            'www.divestfromwarmachine.org'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            _react2.default.createElement(
              'em',
              null,
              '# # #'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: _config2.default.links.ays, title: 'As You Sow', xstrong: true },
              'As You Sow'
            ),
            ' is a nonprofit organization that promotes environmental and social corporate responsibility through shareholder advocacy, coalition building and innovative legal strategies.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _react2.default.createElement(
              _components.Link,
              { to: _config2.default.links.codepink, title: 'CODEPINK', xstrong: true },
              'CODEPINK'
            ),
            ' is a women-led grassroots organization working to end U.S. wars and militarism, support peace and human rights initiatives, and redirect our tax dollars into healthcare, education, green jobs and other life-affirming programs.'
          )
        )
      );
    };

    _this.state = {
      launch: false
    };
    return _this;
  }

  (0, _createClass3.default)(Media, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Media';
      var description = 'Get your money out of weapon stocks. See media related to Weapon Free Funds.';
      var url = _config2.default.domain + _config2.default.routes.media;

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'top' }),
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                title
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answers' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor', id: 'contact' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Get in touch'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-info' },
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'Contact form'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          xstrong: true,
                          styleName: 'contact',
                          to: _config2.default.links.contact,
                          title: 'Contact form' },
                        'As You Sow contact form'
                      )
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'Media Inquiries'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Jill Courtenay, Communications Project Manager, As You Sow'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          xstrong: true,
                          styleName: 'contact',
                          to: _config2.default.links.contactJill,
                          title: 'Email Jill Courtenay, Communications Project Manager, As You Sow' },
                        'Email'
                      )
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'General Inquiries'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Andrew Montes, Director of Digital Strategies, As You Sow'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          xstrong: true,
                          styleName: 'contact',
                          to: _config2.default.links.contactAndrew,
                          title: 'Email Andrew Montes, Director of Digital Strategies, As You Sow  ' },
                        'Email'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Press coverage and blog posts'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-info' },
                    this.pressHits.map(function (pressHit, i) {
                      return _react2.default.createElement(
                        'div',
                        { key: i, styleName: 'press-item' },
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: pressHit.link,
                            title: pressHit.outlet + ' - ' + pressHit.headline },
                          _react2.default.createElement(
                            'h3',
                            { styleName: 'press-item-outlet' },
                            pressHit.outlet
                          ),
                          _react2.default.createElement(
                            'div',
                            null,
                            pressHit.headline
                          )
                        )
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Media releases'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-info' },
                    this.renderReleaseLaunchButton()
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null)
        )
      );
    }
  }]);
  return Media;
}(_react.Component)) || _class);
exports.default = Media;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Media/Media.js
// module id = 1296
// module chunks = 0